let VCA = VCA || {};

VCA.DashboardApptTooltip = (function ($) {
    let ui = {};

    function cacheUI() {
      ui.$WalkInApptType = $('.card-listing__card__link.walk-in');
    }

    function bindEvents() {
        ui.$WalkInApptType.hover(displayTooltip, hideTooltip)
    }
    
    function displayTooltip(e) {
        let el = $(e.currentTarget);
        let wrapper = el.closest('.card-listing__card__tooltip-wrapper');
        let tooltipEl = $(wrapper).find('.card-listing__card__tooltip');
        $(tooltipEl).show();
    }

    function hideTooltip(e) {
        let el = $(e.currentTarget);
        let wrapper = el.closest('.card-listing__card__tooltip-wrapper');
        let tooltipEl = $(wrapper).find('.card-listing__card__tooltip');
        $(tooltipEl).hide();
    }

    function init() {
        cacheUI();
        bindEvents();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    $(document).ready(function() {
        VCA.DashboardApptTooltip.init();
    });
});

